const translations = {
  english: {
    title: "We hope you enjoyed experiencing the Mina & Minel Kupferberg Dollhouse Exhibition at the Schneider Children's Medical Center. If you would like to leave a note of appreciation for Mina and Minel, please fill out this form.",
    name: "Name",
    country: "Country",
    message: "Message",
    city: "City",
    send: "Send Message",
    sent: "Message sent!",
    failed: "Not able to send message. Please try again later.",
    close: "Close",
  },
  hebrew: {
    title: "אנו מקווים שנהניתם מחוויית תערוכת בית הבובות מינה ומינל קופפרברג במרכז שניידר לרפואת ילדים. אם תרצו להשאיר מכתב הערכה למינה ומינל, אנא מלאו טופס זה",
    name: "שם",
    country: "מדינה",
    message: "הודעה",
    city: "עיר",
    send: "שלח הודעה",
    sent: "ההודעה נשלחה!",
    failed: "לא ניתן לשלוח הודעה. נסה שוב מאוחר יותר.",
    close: "סגור",
  },
  arabic: {
    title: "نأمل أن تكونوا قد استمتعتم بتجربة معرض بيت الدمى 'مينا' ومينيل كوبفربرغ في مركز شنايدر الطبي للأطفال. إذا كنتم ترغبون في ترك رسالة تقدير لمينا ومينيل، يرجى ملء هذا النموذج.",
    name: "الاسم",
    country: "الدولة",
    message: "رسالة",
    city: "المدينة",
    send: "إرسال الرسالة",
    sent: "تم إرسال الرسالة!",
    failed: "تعذر إرسال الرسالة. يرجى المحاولة لاحقًا.",
    close: "إغلاق",
  },
};

export default translations;